<app-bottom-sheet [isOpen]="isOpen"
                  [leftButtonText]="'Cancel'"
                  [rightButtonText]="selectedIssueCount > 1 ? 'Assign Rooms' : 'Assign Room'"
                  [leftButtonDisabled]="false"
                  [rightButtonDisabled]="showNoRoomsMessage() || !selectedAreaIdentifier()"
                  [preventOverlayClose]="false"
                  [contentTemplate]="contentTemplate"
                  (isOpenChange)="isOpenChange.emit($event)"
                  (leftButtonClick)="onCancel()"
                  (rightButtonClick)="onAssign()"
                  data-testid="assign-room-bottom-sheet">
</app-bottom-sheet>

<ng-template #contentTemplate>
  <div class="assign-room-sheet"
       data-testid="assign-room-sheet">
    <div class="assign-room-title">Assign Room</div>

    <div class="zone-toggle"
         data-testid="zone-toggle"
         role="tablist"
         aria-label="Room zone filter">
      <button type="button"
              class="zone-toggle-btn"
              [class.active]="selectedZoneGroup() === 'interior'"
              [disabled]="!hasInteriorRooms()"
              [attr.aria-selected]="selectedZoneGroup() === 'interior'"
              (click)="onZoneGroupChange('interior')"
              data-testid="assign-room-zone-interior">
        Interior
      </button>
      <button type="button"
              class="zone-toggle-btn"
              [class.active]="selectedZoneGroup() === 'exterior'"
              [disabled]="!hasExteriorRooms()"
              [attr.aria-selected]="selectedZoneGroup() === 'exterior'"
              (click)="onZoneGroupChange('exterior')"
              data-testid="assign-room-zone-exterior">
        Exterior
      </button>
    </div>

    @if (showNoRoomsMessage()) {
      <p-message severity="secondary"
                 styleClass="no-rooms-message"
                 data-testid="assign-room-no-rooms-message">
        No Rooms Available. Complete BQ7 to sync rooms before assigning this item.
      </p-message>
    } @else {
      <div class="room-list"
           data-testid="assign-room-list"
           role="listbox"
           aria-label="Available rooms">
        @for (room of availableRooms(); track room.identifier) {
          <button type="button"
                  class="room-option"
                  [class.selected]="isRoomSelected(room)"
                  [attr.aria-selected]="isRoomSelected(room)"
                  (click)="onSelectRoom(room)"
                  data-testid="assign-room-option">
            <span class="room-option-radio"
                  [class.selected]="isRoomSelected(room)"
                  aria-hidden="true"></span>
            <span class="room-option-name">{{ room.name }}</span>
          </button>
        }
      </div>
    }
  </div>
</ng-template>